import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface TransportSummaryReportRequest {
  fromDate: string;
  toDate: string;
  center?: string | null;
  programId?: number;
}

export interface TransportSummaryReportRow {
  userName: string;
  phone?: string;
  address?: string;
  transportType: string;
  providedBy: string;
  center: string;
  mealDeliveryStatus?: string;
  mealReceived?: boolean;
  transportDeliveryStatus?: string;
  transportDelivered?: boolean;
  mealDate?: string;
}

export interface TransportSummaryReportResponse {
  statusCode: number;
  message: string;
  fromDate: string;
  toDate: string;
  rows: TransportSummaryReportRow[];
}

@Injectable({
  providedIn: 'root',
})
export class TransportSummaryReportService {
  private readonly apiService = inject(ApiService);

  getReport(request: TransportSummaryReportRequest): Observable<TransportSummaryReportResponse> {
    return this.apiService.post<TransportSummaryReportResponse>(
      API_ENDPOINTS.REPORTS.TRANSPORT_SUMMARY,
      request,
    );
  }
}
